import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import About from "../components/site/About";
import Services from "../components/site/Services";
import Capabilities from "../components/site/Capabilities";
import Engineering from "../components/site/Engineering";
import TrackRecord from "../components/site/TrackRecord";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-[#0B0F19] text-slate-100 overflow-x-hidden">
      <Header />
      <main className="overflow-x-hidden">
        <Hero />
        <About />
        <Services />
        <Capabilities />
        <Engineering />
        <TrackRecord />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
